export default "__VITE_PUBLIC_ASSET__5c1e226e__"